import { useEffect } from 'react';
import { useSetup } from 'hooks/useSetup/useSetup';
import { SetupPanelContainer } from '../setupPanelContainer/SetupPanelContainer';
import { SetupRegCodePanel } from '../setupRegCodePanel/SetupRegCodePanel';
import { SetupBuildingPanel } from '../setupBuildingPanel/SetupBuildingPanel';
import { SetupElevatorPanel } from '../setupElevatorPanel/SetupElevatorPanel';
import { useRouteMatch } from 'react-router';

type HasRegCode = {
    regCode: string;
};

require('./SetupPage.css');

export const SetupPage = () => {
    const { params } = useRouteMatch<HasRegCode>('/setup/:regCode') || {};
    
    const {
        currentPanelIndex,
        changeRegCode,
    } = useSetup();

    useEffect(() => {
        params?.regCode && changeRegCode(params.regCode);
    }, [ params?.regCode, changeRegCode ]);
    
    return (
        <div id="setup-page" className="page">
            <SetupPanelContainer activeIndex={ currentPanelIndex }>
                <SetupRegCodePanel/>
                <SetupBuildingPanel/>
                <SetupElevatorPanel/>
            </SetupPanelContainer>
        </div>
    );
};
